module.exports = __webpack_public_path__ + "static/media/Robot Repair Tech.eea9ad5f.jpg";